import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

export function Logo() {
  return (
    <Link to="/">
      <Box display="flex" alignItems="center">
        <img
          src="assets/icons/logomark.svg"
          alt="Logo aplikacji matematyka gryzie"
          width="40"
          height="32"
        />
        <Typography
          style={{
            marginLeft: 8,
            fontWeight: 400,
          }}
          variant="h5"
          component="h2"
          color="textPrimary"
        >
          #matematykaGryzie
        </Typography>
      </Box>
    </Link>
  );
}

export default Logo;
